import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "toBottom",
  "use": "toBottom-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"toBottom\">\n<rect width=\"14.5714\" height=\"14.5714\" transform=\"translate(15.2858 0.716553) rotate(90)\" fill=\"white\" />\n<path d=\"M12.0983 8.34375L8.00012 12.442L3.9019 8.34375\" stroke=\"#0078FF\" stroke-width=\"1.125\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M7.99982 11.8728L7.99982 3.5625\" stroke=\"#0078FF\" stroke-width=\"1.125\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol